import { Button } from "@hortis/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@hortis/ui/dialog";
import type { ReactNode } from "react";

export const MissingValidationDialog = ({
  open,
  onOpenChange,
  onSubmit,
  children,
  submitText,
}: {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onSubmit: () => void;
  children?: ReactNode;
  submitText?: string;
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    {children}
    <DialogContent data-cy="missing-validation-dialog">
      <DialogHeader>
        <DialogTitle>Save without validation?</DialogTitle>
        <DialogDescription>
          Additional taxonomic data will be unavailable.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose asChild>
          <Button testId="missing-validation-cancel-button">Cancel</Button>
        </DialogClose>
        <Button
          variant="warning"
          onClick={onSubmit}
          testId="missing-validation-confirm-button"
        >
          {submitText ?? "Create taxon"}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
